module.exports = __webpack_public_path__ + "img/pro-img2.f50c1d32.png";